export const environment = {
    production: true,
  //  apiUrl :'https://alltrans-reeng-dev-cus-linux-fxdcczeafga9apf3.centralus-01.azurewebsites.net/API/',
   /// apiUrl:'https://alltrans-reeng-test-cus.azurewebsites.net/API/',
    //https://alltrans-reeng-test-cus.azurewebsites.net/API/
   // geoLocationServiceUrl:"https://alltrans-reeng-dev-cus-linux-fxdcczeafga9apf3.centralus-01.azurewebsites.net/API/api/NearbyVehicle/LocationTrack",
  //  geoLocationServiceUrl:"https://alltrans-reeng-test-cus.azurewebsites.net/API/api/NearbyVehicle/LocationTrack",
  apiUrl:'https://aiq-ats-webapi-dev-b6e9eubsazcwgha4.canadacentral-01.azurewebsites.net/API/',
  geoLocationServiceUrl:"https://aiq-ats-webapi-dev-b6e9eubsazcwgha4.canadacentral-01.azurewebsites.net/API/api/NearbyVehicle/LocationTrack",  
  environment: 'development',
     // Elastic APM Configuration
     apmServerUrl: 'https://apmrum.allcaresoftware.com', // e.g., 'https://your-apm-server.com:8200'
     apmServiceName: 'alltrans-mobile-driver-app',
     apmServiceVersion: '1.0.0'
  };
   //changed to ANDROID_DEV1 from ANDROID_DEV on config and package.json